import { environment as env } from 'src/environments/environment';


export class Log {
  static debug(...args) {
    if (env.isShowLog) {
      console.log(...args);
    }
  }

  static error(...args) {
    if (env.isShowLog) {
      console.error(...args);
    }
  }
}
